import { request } from '@blade/common';
// 搜索中心事件搜索
// export const eventTypes = (data: EventType) => request.post('/api/timedb-management/api/v1/search/image', data);
export const eventTypes = (data) => request
    .post('/api/timedb-management/api/v1/search/query/search', data);
// 检索抓拍图
export const getSnapImageListByImage = eventTypes;
/* @Description: 获取所有视频源
*/
// 搜索中心特征图片上传
export const detectTypes = (data) => request.post('/api/timedb-management/api/v1/search/image/detect', data);
export const getVideoSourceTree = () => request({
    url: '/api/camera-device-management/api/v1/device-groups/devices/tree',
    method: 'POST',
    data: { 'groupId': 0 }
});
/**
 * 首页抓拍记录
 *
 * @param {*} params
 * @return {*}
 */
export const getSnapImageList = (data) => {
    return request.post('/api/timedb-management/api/v1/timeSpace/captureImage/list', data, {
        headers: { hideMessage: true },
    });
};
/**
 * 获取任务详情
 * @param portraitId portraitId
 * @returns
 */
export const getRuleData = (data) => request({
    url: `/api/task-management/api/v1/task/entity/task/rule/portrait`,
    method: 'POST',
    data: data
});
/**
*@Description: 根据设备ID查询视频预览地址
*/
export const getRtsp = (deviceId) => request({
    url: `/api/camera-device-management/api/v1/devices/${deviceId}/rtsp_preview_address`,
    method: 'GET',
});
/**
*@Description: 根据设备ID查询视频预览地址
*/
// 根据设备获取视频流
export const getSeiRtsp = (deviceId, taskId) => request({
    url: `/api/camera-device-management/api/v1/devices/${deviceId}/${taskId}/RTSPPreviewAddress`,
    method: 'GET'
});
/**
*@Description: 根据设备ID查询视频预览地址
*/
export const getRtspMsg = (data) => request({
    url: `/api/task-management/api/v1/task/task/algorithmLayer/deviceIds`,
    method: 'POST',
    data: data
});
export const getAllTaskList = (data) => request({
    url: '/api/task-management/api/v1/task/list/all',
    method: 'POST',
    data
});
// 获取挖掘结果
export const getClusterResult = (id, params) => request({
    url: `/api/portrait-management/api/v1/cluster/result/portrait/${id}`,
    method: 'POST',
    data: params
});
export const getFeatureInfoByObjectId = (data) => request({
    url: `/api/timedb-management/api/v1/search/searchByObjectId`,
    method: 'POST',
    data
});
/**
*@Description: 聚档任务结果详情
*/
export const clusterResultDetail = (data) => request({
    url: `/api/entity-skill-management/api/v1/entity/document/getDocumentDetail`,
    method: 'POST',
    data,
});
/**
*@Description: 解除布控
*/
export const releaseControlApi = (data) => request({
    url: `/api/portrait-management/api/v1/portrait/expire`,
    method: 'POST',
    data,
});
/**
*@Description: 查询配置
*/
export const getConfig = (data) => request({
    url: `/api/task-management/api/v1/task/monitor/alert/config/list`,
    method: 'POST',
    data,
});
/**
*@Description: 修改配置
*/
export const setConfig = (data) => request({
    url: `/api/task-management/api/v1/task/monitor/alert/config/change`,
    method: 'POST',
    data,
});
